import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(2),
    background: theme.palette.warning.contrastText,
    border: `1px solid ${theme.palette.primary.light}`,
    borderLeftWidth: theme.spacing(1),
  },
  alertIcon: {
    color: theme.palette.primary.light,
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
